export default {
  mounted() {
    this.$store.commit('SET_CHANG_LIAN_CONFIG', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ChangLianProductList', title: '同步产品' },
      { name: 'ChangLianOrderList', title: '订单列表' },
      { name: 'ChangLianApiConfigure', title: 'API配置' }
    ])
  }
}
